<div class="container-fluid page">
  <div class="d-flex align-items-center mb-3" style="gap: 20px">
    <span [routerLink]="['/recipient/list']" class="go-back">
      <img src="assets/images/arrow-left.svg" alt="arrow-left" />Recipients List
    </span>
    <img src="assets/images/arrow-right.svg" alt="arrow-right" />
    <ng-container *ngIf="!isEdit">Add</ng-container>
    <ng-container *ngIf="isEdit">Edit</ng-container> Recipient
  </div>
  <form
    class="mat-form"
    [formGroup]="upsertRecipientFrom"
    (ngSubmit)="onSubmit()">
    <div class="row mt-2">
      <div class="col-12">
        <mat-card>
          <mat-card-title>Recipient Details</mat-card-title>
          <mat-divider class="position-relative mb-3"></mat-divider>
          <div class="row">
            <div *appHasPlatformAccess class="col-md-6 form-group">
              <app-input-select
                (selectionChange)="onPartnerSelected($event)"
                [inputData]="attrConstant.partner"
                [selectOptions]="partnerList | async"
                [bindLabel]="'name'"
                [bindValue]="'partner_id'"
                [formControlName]="attrConstant.partner.key"></app-input-select>
            </div>
            <div class="col-md-6 form-group">
              <app-input-select
                (selectionChange)="onSenderSelected($event)"
                [inputData]="attrConstant.sender"
                [selectOptions]="senderList"
                [bindLabel]="'sender_name'"
                [bindValue]="'sender_id'"
                [formControlName]="attrConstant.sender.key"></app-input-select>
            </div>
            <div class="col-md-6 form-group">
              <app-input-template
                [inputData]="attrConstant.firstName"
                [formControlName]="
                  attrConstant.firstName.key
                "></app-input-template>
            </div>
            <div class="col-md-6 form-group">
              <app-input-template
                [inputData]="attrConstant.middleName"
                [formControlName]="
                  attrConstant.middleName.key
                "></app-input-template>
            </div>
            <div class="col-md-6 form-group">
              <app-input-template
                [inputData]="attrConstant.lastName"
                [formControlName]="
                  attrConstant.lastName.key
                "></app-input-template>
            </div>
            <div class="col-md-6 form-group">
              <app-input-datepicker
                [inputData]="attrConstant.dob"
                [formControlName]="attrConstant.dob.key"></app-input-datepicker>
            </div>
            <div class="col-md-6 form-group">
              <app-input-select
                [inputData]="attrConstant.gender"
                [selectOptions]="gender"
                [bindLabel]="'name'"
                [bindValue]="'value'"
                [formControlName]="attrConstant.gender.key"></app-input-select>
            </div>
            <div class="col-md-1 col-2 form-group">
              <app-input-template
                [inputData]="attrConstant.mobileCode"
                [formControlName]="
                  attrConstant.mobileCode.key
                "></app-input-template>
            </div>
            <div class="col-md-5 col-10 form-group ps-0">
              <app-input-template
                [inputData]="attrConstant.mobileNumber"
                [formControlName]="
                  attrConstant.mobileNumber.key
                "></app-input-template>
            </div>
            <div class="col-md-6 form-group">
              <app-input-template
                [inputData]="attrConstant.email"
                [formControlName]="attrConstant.email.key"></app-input-template>
            </div>
            <div class="col-md-6 form-group">
              <app-input-template
                [inputData]="attrConstant.beneAddress"
                [formControlName]="
                  attrConstant.beneAddress.key
                "></app-input-template>
            </div>
            <div class="col-md-6 form-group">
              <app-input-template
                [inputData]="attrConstant.beneCity"
                [formControlName]="
                  attrConstant.beneCity.key
                "></app-input-template>
            </div>
            <div class="col-md-6 form-group">
              <app-input-template
                [inputData]="attrConstant.benePostCode"
                [formControlName]="
                  attrConstant.benePostCode.key
                "></app-input-template>
            </div>
            <div class="col-md-6 form-group">
              <app-input-select
                (selectionChange)="onBeneCountrySelected($event)"
                [inputData]="attrConstant.beneCountry"
                [selectOptions]="beneCountry | async"
                [bindLabel]="'countryName'"
                [bindValue]="'countryCode'"
                [formControlName]="
                  attrConstant.beneCountry.key
                "></app-input-select>
            </div>
            <div class="col-md-6 form-group">
              <app-input-template
                [inputData]="attrConstant.senderBeneRelation"
                [formControlName]="
                  attrConstant.senderBeneRelation.key
                "></app-input-template>
            </div>
            <div class="col-md-6 form-group">
              <mat-checkbox [formControlName]="attrConstant.isFavorite.key">
                Is Favorite
              </mat-checkbox>
            </div>
          </div>
          <mat-divider class="position-relative mb-3"></mat-divider>
          <app-transfer-details
            [group]="upsertRecipientFrom"
            [destinationCountry]="
              upsertRecipientFrom.get(attrConstant.beneCountry.key)?.value
            "></app-transfer-details>
        </mat-card>
      </div>
    </div>
    <button class="btn primary-btn w-100 mt-3">Submit</button>
  </form>
</div>
